import { Box, Typography } from "@mui/material";
import styled from "styled-components";

import Colors from "@constants/Colors";

export const StyledBox = styled(Box)<{
  isDesktop: boolean;
}>`
  width: 100%;
  display: flex !important;
  gap: 7px !important;
  padding: ${(props) => (props.isDesktop ? "80px 0" : "46px 0")}!important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0 0 4px 4px !important;
  border-top: none !important;
  margin: auto;
`;

export const StyledTypography = styled(Typography)`
  font-family: "Ringside Regular-Book" !important;
  font-weight: 325 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  color: ${Colors.neutral_gray_500} !important;
`;
